/* @flow */

export const FETCH_EVENT_TOPIC_INSPIRATIONS = 'FETCH_EVENT_TOPIC_INSPIRATIONS';
export const FETCH_EVENT_TOPIC_INSPIRATIONS_SUCCESS =
  'FETCH_EVENT_TOPIC_INSPIRATIONS_SUCCESS';
export const FETCH_EVENT_TOPIC_INSPIRATIONS_FAILURE =
  'FETCH_EVENT_TOPIC_INSPIRATIONS_FAILURE';
